import {LitElement, html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {when} from 'lit/directives/when.js';
import {connect} from 'pwa-helpers';
import store from '../../../store';


@customElement('visual-lightprofile-summary')
export class VisualLightprofileSummary extends connect(store)(LitElement) {

	static styles = [
		css`

			.container {
				max-width: 100vw;
			}

        `
	];

	constructor() {
	  super();
	  store.subscribe(() => this.requestUpdate());
	}

	stateChanged(state) {
	  this.state = state;
	  this.translations = state.productData.translations;
	  this.profile = state.lightProfile.data.profile;
	  this.lightProfile = state.lightProfile.data;
	}

	render() {
		const s = this.state;
		return html`
			<div class="container">
				<visual-lightprofile-summary-header></visual-lightprofile-summary-header>
				<visual-lightprofile-summary-details></visual-lightprofile-summary-details>
				${when(this.lightProfile.project.luminary === null,
					() => html`
						<visual-lightprofile-summary-lamps-grid></visual-lightprofile-summary-lamps-grid>`,
					() => html`
						<visual-lightprofile-summary-lamps-luminary-grid></visual-lightprofile-summary-lamps-luminary-grid>
						<visual-lightprofile-summary-lamp-data></visual-lightprofile-summary-lamp-data>
						<visual-lightprofile-summary-tender-text></visual-lightprofile-summary-tender-text>
						<visual-lightprofile-summary-colors></visual-lightprofile-summary-colors>`
				)}
				<visual-lightprofile-summary-footer></visual-lightprofile-summary-footer>
			</div>
		`;
	}
}
